<template>
  <div class="c-square-index" :class="{'-active': state}">
    <div class="__slot" v-show="false"><slot></slot></div>
    <div class="c-square-index__inner">
      <ul class="c-square-index__list">
        <li class="c-square-index__item" v-for="(item, index) in list" :key="index" v-if="item.state">
          <a :href="item.href" v-background="item.image">
            <span class="c-square-index__caption">
              {{item.caption}}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import u from "../lib/u.js";

export default {

  data (){
    return {
      state: false,
      list: []
    }
  },

  directives: {
    background (el, o){
      el.style.backgroundImage = `url(${o.value})`;
    }
  },

  mounted (){
    this.list = Array.from(this.$el.querySelectorAll(".__slot li"))
    .map((li) => {
      let item = {
        href: u.exists(li.querySelector("a"), "href"),
        image: u.exists(li.querySelector("img"), "src"),
        caption: u.exists(li.querySelector(".caption"), "innerText")
      };

      if(item.href && item.image && item.caption){
        item.state = true;
      }
      return item;
    });

    setTimeout(() => {
      this.state = true;
    }, 100);
  }

}
</script>




// WEBPACK FOOTER //
// src/component/square-index.vue